// extracted by mini-css-extract-plugin
module.exports = {"h1":"LoginPage_h1_1LSbU"};